module.exports = __webpack_public_path__ + "static/media/3DPPA6.4de540d4.jpg";